import axios from '@/common/axios';

export default {
    //获取信息
    getRepayInfo(params) {
        return axios.post('/repay/info', params, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
    },
    //提交用户付款钱包号码
    paymentConfirm(params) {
        return axios.post('/repay/wallet/confirm', params, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
    },
    //修改用户付款钱包号码
    updateWallet(params) {
        return axios.post('/repay/wallet/update', params, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
    },
    queryResult(params) {
        return axios.post('/v2/repay/result', params, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
    },
    updateTransactionId(params) {
        return axios.post('/repay/pay/confirm', params, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
    },
}